import {gql} from 'apollo-angular';

export const SEND_GAME_TROPHY_HUNT_ANSWER = gql`
  query SendGameTrophyHuntAnswer($entryId: Int!, $resultString: String!) {
    sendGameTrophyHuntAnswer(gameTrophyHuntSchoolClassEntryID: $entryId, resultString: $resultString) {
      isCorrect
      isComplete
    }
  }
`;
